<!-- FILE: src/views/RegistrationForm.vue -->
<template>
    <div class="container my-4">
        <!-- Banner Section -->
        <div class="banner text-white text-center p-4 mb-4 shadow-sm">
            <i class="fas fa-quran fa-2x mb-2"></i>
            <h2>مسابقة تارجت لحفظ القرآن الكريم</h2>
            <p class="lead mb-0">انضم إلينا في رحلة إيمانية مباركة. باب التسجيل مفتوح الآن!</p>
        </div>

        <!-- Form Card Section -->
        <div class="card shadow-lg">
            <div class="card-header bg-success text-white text-center">
                <h3>نموذج تسجيل الاشتراك</h3>
            </div>
            <div class="card-body p-4 p-md-5">
                <!-- رسالة النجاح أو الخطأ -->
                <div v-if="message" :class="['alert', success ? 'alert-success' : 'alert-danger']">
                    {{ message }}
                </div>

                <form @submit.prevent="submitForm" enctype="multipart/form-data">

                    <!-- Basic Info -->
                    <div class="mb-3">
                        <label for="name" class="form-label">اسم المشترك (رباعي)</label>
                        <div class="input-group">
                            <input type="text" class="form-control" id="name" v-model="form.name"
                                placeholder="ادخل الاسم هنا" required>
                            <!-- <span class="input-group-text"><i class="fas fa-user"></i></span> -->
                        </div>
                    </div>

                    <div class="mb-4">
                        <label for="nationalId" class="form-label">الرقم القومي (14 رقم)</label>
                        <div class="input-group">
                            <input type="text" class="form-control" id="nationalId" v-model="form.national_id"
                                @input="extractFromNationalId" maxlength="14" pattern="\d{14}" title="يجب إدخال 14 رقم"
                                placeholder="يبدأ بـ 2 أو 3" required>
                            <!-- <span class="input-group-text"><i class="fas fa-id-card"></i></span> -->
                        </div>
                    </div>

                    <hr class="my-4">
                    <h5 class="text-center text-secondary mb-4">بيانات مستخرجة تلقائياً</h5>

                    <!-- Auto-filled Data -->
                    <div class="row">
                        <div class="col-md-4 mb-3">
                            <label for="dob" class="form-label">تاريخ الميلاد</label>
                            <input type="text" class="form-control" id="dob" v-model="form.dob" readonly>
                        </div>
                        <div class="col-md-4 mb-3">
                            <label for="gender" class="form-label">النوع</label>
                            <input type="text" class="form-control" id="gender" v-model="form.gender" readonly>
                        </div>
                        <div class="col-md-4 mb-3">
                            <label for="birthGovernorate" class="form-label">محافظة الميلاد</label>
                            <input type="text" class="form-control" id="birthGovernorate"
                                v-model="form.birth_governorate" readonly>
                        </div>
                    </div>

                    <hr class="my-4">
                    <h5 class="text-center text-secondary mb-4">بيانات العنوان والاشتراك</h5>

                    <!-- Additional Info -->
                    <div class="mb-3">
                        <label for="address" class="form-label">العنوان بالتفصيل</label>
                        <div class="input-group">
                            <textarea class="form-control" id="address" v-model="form.address" rows="2"
                                placeholder="مثال: شارع الجمهورية - بجوار المسجد الكبير" required></textarea>
                            <!-- <span class="input-group-text"><i class="fas fa-map-marker-alt"></i></span> -->
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-6 mb-3">
                            <label for="addressGovernorate" class="form-label">المحافظة</label>
                            <select class="form-select" id="addressGovernorate" v-model="form.address_governorate"
                                @change="populateRegions" required>
                                <option value="north_sinai" selected>شمال سيناء</option>
                            </select>
                        </div>
                        <div class="col-md-6 mb-3">
                            <label for="addressRegion" class="form-label">المنطقة / المركز</label>
                            <select class="form-select" id="addressRegion" v-model="form.address_region" required>
                                <option value="" disabled selected>-- اختر المنطقة --</option>
                                <option v-for="region in availableRegions" :key="region" :value="region">{{ region }}
                                </option>
                            </select>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-6 mb-3">
                            <label for="phone1" class="form-label">رقم الهاتف الأساسي</label>
                            <div class="input-group">
                                <input type="tel" class="form-control" id="phone1" v-model="form.phone"
                                    placeholder="01xxxxxxxxx" required>
                                <span class="input-group-text"><i class="fas fa-phone"></i></span>
                            </div>
                        </div>
                        <div class="col-md-6 mb-3">
                            <label for="phone2" class="form-label">رقم هاتف إضافي (اختياري)</label>
                            <div class="input-group">
                                <input type="tel" class="form-control" id="phone2" v-model="form.phone2"
                                    placeholder="01xxxxxxxxx">
                                <!-- <span class="input-group-text"><i class="fas fa-mobile-alt"></i></span> -->
                            </div>
                        </div>
                    </div>
                    <hr class="my-4">
                    <h5 class="text-center text-secondary mb-4">بيانات الدخول</h5>

                    <div class="row">
                        <div class="col-md-6 mb-3">
                            <label for="password" class="form-label">كلمة المرور</label>
                            <div class="input-group">
                                <input type="password" class="form-control" id="password" v-model="form.password"
                                    required>
                                <!-- <span class="input-group-text"><i class="fas fa-lock"></i></span> -->
                            </div>
                        </div>
                        <div class="col-md-6 mb-3">
                            <label for="password_confirmation" class="form-label">تأكيد كلمة المرور</label>
                            <div class="input-group">
                                <input type="password" class="form-control" id="password_confirmation"
                                    v-model="form.password_confirmation" required>
                                <!-- <span class="input-group-text"><i class="fas fa-lock"></i></span> -->
                            </div>
                        </div>
                    </div>
                    <div class="mb-3">
                        <label for="birthCertificate" class="form-label">صورة شهادة الميلاد (اختياري)</label>
                        <div class="input-group">
                            <input class="form-control" type="file" id="birthCertificate" @change="handleFileUpload"
                                accept="image/png, image/jpeg, image/jpg">
                            <!-- <span class="input-group-text"><i class="fas fa-file-image"></i></span> -->
                        </div>
                    </div>

                    <div class="mb-3">
                        <label for="educationStage" class="form-label">المرحلة الدراسية</label>

                        <select class="form-select" id="subscriptionType" v-model="form.education_stage" required>
                            <option value="" disabled selected>-- المرحلة الدراسية --</option>
                            <option value="g1">المرحلة الابتدائية ( عام )</option>
                            <option value="g2">المرحلة الابتدائية ( ازهر )</option>
                            <option value="z1">المرحلة اﻻعدادية ( عام )</option>
                            <option value="z2">المرحلة اﻻعدادية ( ازهر )</option>

                        </select>


                    </div>

                    <div class="mb-4">
                        <label for="subscriptionType" class="form-label">مستوى المسابقة</label>
                        <select class="form-select" id="subscriptionType" v-model="form.subscription_type" required>
                            <option value="" disabled selected>-- اختر المستوى --</option>
                            <option value="level1">المستوى الأول (القرآن كاملاً)</option>
                            <option value="level2">المستوى الثاني (نصف القرآن)</option>
                            <option value="level3">المستوى الثالث (10 أجزاء أو أقل)</option>

                        </select>
                    </div>

                    <div class="d-grid">
                        <button type="submit" class="btn btn-success btn-lg" :disabled="isLoading">
                            {{ isLoading ? 'جاري التسجيل...' : 'تسجيل البيانات' }}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import api from '../api/axios'; // استيراد إعدادات axios
import auth from '../services/auth';
export default {
    name: 'RegistrationForm',
    data() {
        return {
            form: {
                name: '',
                national_id: '',
                dob: '',
                gender: '',
                birth_governorate: '',
                address: '',
                address_governorate: 'north_sinai',
                address_region: '',
                phone: '',
                phone2: '',
                education_stage: '',
                subscription_type: '',
                birth_certificate: null,
                password: '',
                password_confirmation: '',
            },
            governoratesData: {
                '01': 'القاهرة', '02': 'الإسكندرية', '03': 'بورسعيد', '04': 'السويس',
                '11': 'دمياط', '12': 'الدقهلية', '13': 'الشرقية', '14': 'القليوبية',
                '15': 'كفر الشيخ', '16': 'الغربية', '17': 'المنوفية', '18': 'البحيرة',
                '19': 'الإسماعيلية', '21': 'الجيزة', '22': 'بني سويف', '23': 'الفيوم',
                '24': 'المنيا', '25': 'أسيوط', '26': 'سوهاج', '27': 'قنا',
                '28': 'أسوان', '29': 'الأقصر', '31': 'البحر الأحمر', '32': 'الوادي الجديد',
                '33': 'مطروح', '34': 'شمال سيناء', '35': 'جنوب سيناء', '88': 'خارج الجمهورية'
            },
            regionsData: {
                north_sinai: ['العريش', 'بئر العبد', 'الشيخ زويد', 'رفح', 'الحسنة', 'نخل']
            },
            availableRegions: [],
            isLoading: false,
            message: '',
            success: false,
        };
    },
    methods: {
        populateRegions() {
            const selectedGov = this.form.address_governorate;
            this.availableRegions = this.regionsData[selectedGov] || [];
            this.form.address_region = ''; // Reset region selection
        },
        extractFromNationalId() {
            const id = this.form.national_id;
            if (id.length !== 14 || !/^\d{14}$/.test(id)) {
                this.form.dob = '';
                this.form.gender = '';
                this.form.birth_governorate = '';
                return;
            }

            const centuryDigit = id.substring(0, 1);
            const year = id.substring(1, 3);
            const month = id.substring(3, 5);
            const day = id.substring(5, 7);
            const birthYear = (centuryDigit === '2' ? '19' : '20') + year;
            this.form.dob = `${day}/${month}/${birthYear}`;

            const genderDigit = id.substring(12, 13);
            this.form.gender = (parseInt(genderDigit) % 2 !== 0) ? 'ذكر' : 'أنثى';

            const govCode = id.substring(7, 9);
            this.form.birth_governorate = this.governoratesData[govCode] || 'غير معروف';
        },
        handleFileUpload(event) {
            this.form.birth_certificate = event.target.files[0];
        },
        async submitForm() {
            this.isLoading = true;
            this.message = '';

            const formData = new FormData();
            for (const key in this.form) {
                if (this.form[key]) {
                    formData.append(key, this.form[key]);
                }
            }

            try {
                const response = await api.post('/register', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });
                this.success = true;
                this.message = 'تم تسجيل بياناتك بنجاح!';
                this.handleLogin();
                this.resetForm();
            } catch (error) {
                this.success = false;
                if (error.response && error.response.data.errors) {
                    // تحويل مصفوفة الأخطاء إلى نص
                    this.message = Object.values(error.response.data.errors).flat().join('\n');
                } else {
                    this.message = 'حدث خطأ أثناء التسجيل. يرجى المحاولة مرة أخرى.';
                }
            } finally {
                this.isLoading = false;
            }
        },
        resetForm() {
            Object.keys(this.form).forEach(key => {
                this.form[key] = (key === 'address_governorate') ? 'north_sinai' : (key === 'birth_certificate' ? null : '');
            });
            document.getElementById('birthCertificate').value = null; // إعادة تعيين حقل الملف
            this.populateRegions();
        },
        async handleLogin() {

            try {
                const data = await auth.login({ email: this.form.national_id, password: this.form.password });

                // التوجيه بناءً على دور المستخدم
                if (data.user.role === 'admin' || data.user.role === 'judge') {
                    this.$router.push({ name: 'Reports' });
                } else if (data.user.role === 'contestant') {
                    this.$router.push({ name: 'Profile' });
                } else {
                    this.$router.push('/'); // صفحة افتراضية
                }

            } catch (err) {
                // ...
            } finally {
                // ...
            }
        },
    },

    created() {
        this.populateRegions(); // استدعاء الدالة عند إنشاء المكون لملء المناطق لأول مرة
    }
};
</script>

<style scoped>
/* يمكنك وضع الـ CSS الخاص بالفورم هنا. بما أنه يستخدم Bootstrap، فالتنسيقات العامة كافية */
body {
    /* هذا لن يعمل في scoped style، لكن بما أن التنسيق عام، يمكن نقله إلى App.vue أو public/index.html */
    font-family: 'Cairo', sans-serif;
    background-color: #f0f2f5;
}

.banner {
    background: linear-gradient(45deg, #28a745, #218838);
    border-radius: 0.5rem;
}

.card-header {
    font-weight: 700;
}

.input-group-text {
    width: 42px;
    /* توحيد عرض أيقونات الإدخال */
    justify-content: center;
}

/* يمكنك إضافة أي تنسيقات مخصصة هنا */
</style>